import React, { useState } from "react";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { useFont } from "../../contexts/FontContext/FontContext";
import TextInput from "../TextInput/TextInput";
import styles from "./ChangeAddress.module.css";

const libraries = ["places"]; // Load the places library

const ChangeAddress = ( { setNewAddress } ) => {
    const [address, setAddress] = useState("");
    const [autocomplete, setAutocomplete] = useState(null);
    const [isValidAddress, setIsValidAddress] = useState(false); // Track validity of the address
    const fontSchemes = useFont();
    const fontFamilyOne = fontSchemes.scheme_one;

    const { isLoaded } = useLoadScript({ googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, libraries });

    if (!isLoaded) return <div>Loading...</div>;

    const handlePlaceChanged = () => {
        if (autocomplete) {
            const place = autocomplete.getPlace();
            if (place.formatted_address) {
                const addressComponents = extractAddressComponents(place);
                // Ensure required fields exist
                if (addressComponents.address1 && addressComponents.city && addressComponents.state && addressComponents.zip) {
                    setAddress(place.formatted_address);
                    setIsValidAddress(true);
                } else { setIsValidAddress(false); }
            } else {
                setAddress("");
                setIsValidAddress(false);
            }
        }
    };

    const handleBlur = () => { if (!isValidAddress) setAddress(""); };

    //at minimum, address1, city, provingce (state), and zip are required
    const extractAddressComponents = (place) => {
        let address1 = "", address2 = "", city = "", state = "", zip = "";
        place.address_components.forEach((component) => {
            const types = component.types;
            if (types.includes("street_number")) { address1 = component.long_name; } 
            else if (types.includes("route")) { address1 += ` ${component.long_name}`; } 
            else if (types.includes("subpremise")) { address2 = component.long_name; } 
            else if (types.includes("locality")) { city = component.long_name; } 
            else if (types.includes("administrative_area_level_1")) { state = component.short_name; } 
            else if (types.includes("postal_code")) { zip = component.long_name; }
        });
        return { address1: address1.trim(), address2, city, state, zip };
    };

    return (
        <div className={styles.change_address_container}>
            <p className={`titles ${fontFamilyOne}`}>Enter a new address</p>
            <div className={styles.address_input_wrapper}>
                <Autocomplete onLoad={(autocompleteInstance) => setAutocomplete(autocompleteInstance)} onPlaceChanged={handlePlaceChanged}>
                    <TextInput inputType={"business_address"} value={address} onChange={(e) => setAddress(e.target.value)} onBlur={handleBlur} />
                </Autocomplete>
            </div>
            <div style={{ marginTop: "10px" }}>
                <button onClick={() => setNewAddress(address)} disabled={!isValidAddress} style={{ cursor: isValidAddress ? "pointer" : "not-allowed" }} className={`login_buttons ${styles.save_new_address_button} ${fontFamilyOne}`}>Save</button>
            </div>
        </div>
    );
};

export default ChangeAddress;
